import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Loader = ({ loadingMsg = "Loading...", percentage = 0 }) => {
  const radius = 40;
  const stroke = 6;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="loader-wrapper d-flex justify-content-center align-items-center">
      <style>
        {`
          .loader-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 10;
            background: transparent;
            font-family: Arial, sans-serif;
          }
          .progress-ring__circle {
            transition: stroke-dashoffset 0.1s linear;
            stroke: #0d6efd; 
            transform: rotate(-90deg);
            transform-origin: 50% 50%;
          }
          .progress-background {
             stroke: #e9ecef;
          }
        `}
      </style>

      <div className="position-relative d-flex justify-content-center align-items-center">
        <svg height={radius * 2} width={radius * 2}>
          {/* Background Circle */}
          <circle
            className="progress-background"
            strokeWidth={stroke}
            fill="transparent"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {/* Progress Circle */}
          <circle
            className="progress-ring__circle"
            strokeWidth={stroke}
            strokeDasharray={circumference + " " + circumference}
            style={{ strokeDashoffset }}
            strokeLinecap="round"
            fill="transparent"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        <div
          className="position-absolute text-primary fw-bold"
          style={{ fontSize: "0.9rem" }}
        >
          {Math.round(percentage)}%
        </div>
      </div>

    </div>
  );
};

export default Loader;
